import { useState } from "react";

import { SpinnerIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

interface ImageProps {
  src: string;
  alt: string;
  fallbackSrc: string;
  className?: string;
}

export const Image = ({
  src,
  alt,
  fallbackSrc,
  className = ""
}: ImageProps) => {
  const [hasError, setHasError] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const handleError = () => {
    setHasError(true);
  };

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div
      aria-label="Image Container"
      className={twMerge("relative w-full h-auto", className)}
    >
      <img
        src={hasError ? fallbackSrc : src}
        alt={alt}
        onError={handleError}
        onLoad={handleLoad}
        className={`w-full h-auto transition-filter duration-300 ${
          isLoaded ? "filter-none" : "filter blur-[10px]"
        }`}
      />
      {!isLoaded && (
        <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
          <SpinnerIcon className="w-6 h-6 animate-spin" />
        </div>
      )}
    </div>
  );
};

export default Image;
